/* Source: /app/main.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { app as ClientApp } from "./frontend.js";
function App() {
  return __jacJsx(ClientApp, {}, []);
}
const app = App;
/*jac:refresh-boundary*/;
export {app};
//# sourceMappingURL=main.js.map
